import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a17fbf0d6425f00149b3272_1781774361987_0d722a5f/landingclone/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a17fbf0d6425f00149b3272_1781774361987_0d722a5f/landingclone/src/components/Navbar.tsx");
